export function disableIndentedCode() {
  //@ts-ignore
  const data = this.data();
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);

  micromarkExtensions.push({
    disable: { null: ['codeIndented'] },
  });
}
